import { render, staticRenderFns } from "./OrderState.vue?vue&type=template&id=4ba24f55&scoped=true"
import script from "./OrderState.vue?vue&type=script&lang=js"
export * from "./OrderState.vue?vue&type=script&lang=js"
import style0 from "./OrderState.vue?vue&type=style&index=0&id=4ba24f55&prod&lang=scss&scoped=true"
import style1 from "./OrderState.vue?vue&type=style&index=1&id=4ba24f55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba24f55",
  null
  
)

export default component.exports